import { render, staticRenderFns } from "./EscalationTemplateForm.vue?vue&type=template&id=068ef431"
import script from "./EscalationTemplateForm.vue?vue&type=script&lang=js"
export * from "./EscalationTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports